package com.essntl.features.message.ui.chat.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.message.ui.all_conversation.AllConversationState
import com.essntl.uikit.components.chat.contact.ContactAvatar
import com.essntl.uikit.components.chat.contact.ContactUiState
import com.essntl.uikit.components.chat.conversation.ConversationType
import com.essntl.uikit.components.chat.conversation.overviewcard.ConversationOverviewUiState
import com.essntl.uikit.components.chat.conversation.overviewcard.EsConversationTypeUi
import com.essntl.uikit.components.chat.group.GroupAvatar
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ChatHeader(
    conversationUiState: ConversationOverviewUiState,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        modifier = modifier,
    ) {
        if (conversationUiState.type == ConversationOverviewUiState.ChatType.Contact)
            ContactAvatar(
                initials = conversationUiState.contact.initials,
                isOnline = conversationUiState.contact.isOnline,
            )
        else if (conversationUiState.type == ConversationOverviewUiState.ChatType.Group)
            GroupAvatar()

        Column(
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            Text(
                text = conversationUiState.contact.name ?: conversationUiState.contact.phoneNumber ?: "Unknown",
                style = MaterialTheme.esTypography.h4SemiBold20.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
            )

            if (conversationUiState.type == ConversationOverviewUiState.ChatType.Contact)
                EsConversationTypeUi(conversationType = conversationUiState.conversationType)
            else if (conversationUiState.type == ConversationOverviewUiState.ChatType.Group)
                Text(
                    text = conversationUiState.participants.orEmpty().joinToString(", "),
                    style = MaterialTheme.esTypography.c1Medium13.copy(
                        color = MaterialTheme.esColorScheme.textSecondary,
                    ),
                    overflow = TextOverflow.Ellipsis,
                )
        }
    }
}